<template>
  <div id="app">
    <!-- <img alt="Vue logo" src="./assets/logo.png"> -->
    <!-- <HelloWorld msg="Welcome to Your Vue.js App"/> -->
     <!-- <MainPage/> -->
      <router-view />
  </div>
</template>

<script>
// import HelloWorld from './components/HelloWorld.vue'
// import MainPage from './components/MainPage.vue'

export default {
  name: 'App',
  // components: {
  //   // HelloWorld
  //   MainPage
  // }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  display: flex;
  flex-direction: column;
}

html, body {
  margin: 0;
  padding: 0;
  height: 100%;
}
</style>
